import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";

const Contact = () => {
  const [menu, setMenu] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    getMenu();

    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const getMenu = () => {
    fetch("/json/aboutMenu.json")
      .then((response) => response.json())
      .then((data) => setMenu(data))
      .catch((error) => console.error("menu:", error));
  };
  const guideData = [
    {
      id: 1,
      title: "Office Locations",
    },
  ];
  return (
    <div>
      <div className="page-title">
        <h1>Contact Us</h1>
      </div>
      <Row>
        <Col xs={12} md={3}>
          <Card
            style={{
              maxHeight: isMobile
                ? "calc(100vh - 40px)"
                : "calc(100vh - 100px)",
              overflowY: "auto",
              padding: isMobile ? "1rem" : "1.5rem",
              position: isMobile ? "static" : "sticky",
              top: isMobile ? "auto" : "100px",
              left: isMobile ? "auto" : 0,
              zIndex: 10,
            }}
          >
            <Card.Header className="tab-header">
              <h3
                style={{
                  color: "#2c3e50",
                  paddingBottom: "10px",
                  margin: 0,
                  fontSize: isMobile ? "1.2rem" : "1.3rem",
                }}
              >
                Overview
              </h3>
            </Card.Header>
            <Card.Body style={{ padding: 0 }}>
              <ul className="p-0">
                {menu.map(({ id, title, link }) => (
                  <li key={id}>
                    <a
                      href={link}
                      className={`btn d-flex justify-content-between align-items-center btn-secondary`}
                      style={{
                        display: "block",
                        textAlign: "left",
                        padding: "8px 15px",
                        borderRadius: "8px",
                        transition: "all 0.3s ease",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          flexGrow: 1,
                          marginRight: "8px",
                        }}
                      >
                        {title}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={9}>
          <main style={{ flex: "1" }}>
            {guideData.map((it) => (
              <section key={it.id} id={it.id} className="card mb-25">
                <h2 className="mb-20 h2-title">{it.title}</h2>
                {it.id === 1 && (
                  <div
                    style={{
                      lineHeight: "1.8",
                      color: "#555",
                      fontSize: "1.05rem",
                    }}
                  >
                    <div style={{ fontWeight: "bold"}}>
                      Head Office
                    </div>
                    <div>
                    Room 516, 5th Floor, Yee Fat Industrial Building, No. 35
                      Tai Yau Street, San Po Kong, Hong Kong
                    </div>
                  </div>
                )}
                {it.id === 2 && (
                  <div
                    style={{
                      lineHeight: "1.8",
                      color: "#555",
                      fontSize: "1.05rem",
                    }}
                  >
                    <p>
                      <b>Official Email:</b>
                      <br />
                      editorial@fargroups.com
                    </p>
                    <p>
                      <b>Current Molecular Pharmacology Email:</b>
                      <br />
                      cmp@fargroups.com
                    </p>
                    <p>
                      <b>Current Pharmaceutical Analysis Email:</b>
                      <br />
                      cpa@fargroups.com
                    </p>
                    <p>
                      <b>Technology Email:</b>
                      <br />
                      technology@fargroups.com
                    </p>
                  </div>
                )}
              </section>
            ))}
          </main>
        </Col>
      </Row>
    </div>
  );
};
export default Contact;
